import { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import DocumentRequestItem from './DocumentRequestItem';
import { TransactionItemLoader } from './TransactionItemLoader';
import i18nContext from 'components/i18n-context';
import { useMediaQuery } from 'services/useMediaQUery';
import { MEDIA_QUERY } from 'services/utils';
import './LatestTransactions.scss';

const documentRequestsTableMaxHeight = 280;

const DocumentRequestsList = ({ documentRequests = [], isLoading = false, onUploadClick = () => {} }) => {
  const i18n = useContext(i18nContext);
  const isMobile = useMediaQuery(MEDIA_QUERY.DASHBOARD_RESPONSIVE);
  const tableWrapperRef = useRef(null);

  useEffect(() => {
    if (tableWrapperRef.current) {
      if (tableWrapperRef.current.scrollHeight > documentRequestsTableMaxHeight) {
        tableWrapperRef.current.style.overflowY = 'auto';
      } else {
        tableWrapperRef.current.style.overflowY = 'hidden';
      }
    }
  }, [documentRequests]);

  if (isMobile) {
    return (
      <div className='compliance-requests-mobile-wrapper'>
        {isLoading
          ? [...Array(3).keys()].map((index) => <TransactionItemLoader isMobile={isMobile} key={index} />)
          : documentRequests.map((request) => (
              <DocumentRequestItem
                isMobile={isMobile}
                key={request.id}
                request={request}
                onUploadClick={() => onUploadClick(request.id)}
              />
            ))}
      </div>
    );
  }

  return (
    <div
      className='compliance-requests-table-wrapper'
      ref={tableWrapperRef}
      style={{ maxHeight: documentRequestsTableMaxHeight }}
    >
      <table className='transactions-wrapper'>
        <thead>
          <tr>
            <th className='date-column'>
              <span>{i18n.getMessage('documentRequests.table.transactionId')}</span>
            </th>
            <th className='date-column'>
              <span>{i18n.getMessage('documentRequests.table.expiresDate')}</span>
            </th>
            <th className='counterparty-column'>
              <span>{i18n.getMessage('documentRequests.table.counterparty')}</span>
            </th>
            <th className='reference-column'>
              <span>{i18n.getMessage('documentRequests.table.reference')}</span>
            </th>
            <th className='amount-column'>
              <span>{i18n.getMessage('documentRequests.table.amount')}</span>
            </th>
            <th className='status-column'>
              <span>{i18n.getMessage('documentRequests.table.status')}</span>
            </th>
            <th className='upload-column'>
              <span>{i18n.getMessage('documentRequests.table.upload')}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading
            ? [...Array(3).keys()].map((index) => <TransactionItemLoader key={index} />)
            : documentRequests.map((request) => (
                <DocumentRequestItem
                  key={request.id}
                  request={request}
                  onUploadClick={() => onUploadClick(request.id)}
                />
              ))}
        </tbody>
      </table>
    </div>
  );
};

DocumentRequestsList.propTypes = {
  documentRequests: PropTypes.array,
  isLoading: PropTypes.bool,
  onUploadClick: PropTypes.func
};

export default DocumentRequestsList;
